<template>
  <div id="header-box">
    <div class="box logo">
      <router-link tag="a" to="/">rebar</router-link>
    </div>
    
    <div class="box" id="menu">
      <router-link tag="a" to="/data">Data</router-link>
      <router-link tag="a" to="/model">Models</router-link>
    </div>
  </div>
</template>

<script>
const d3 = require('d3');
const d3arr = require('d3-array');

export default {
  name: 'Header'
}
</script>

<style scoped>
#header-box {
  display: flex;
  align-items: center;
  width: 100%;
  background: #0666B4;
  color: #ffffff;
}

a {
  /* Text including Links */
  color: #ffffff;
  font-size: 1.2em;
  font-weight: bold;
  text-decoration: none;
}

.box {
  flex: 1;
  display: flex;
  justify-content: center;
}

.logo {
  margin: 1% 10%;
}
.logo > a {
  margin-right: auto;
}

#menu {
  max-width: 400px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

@media only screen and (max-width: 600px) {
  .logo {
    flex: .5;
  }
}
</style>